"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray2(arr) { return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2(); }

function _nonIterableSpread2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _iterableToArray2(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Internal Component: SMB Subcategory Menu - Version: 1.3.56
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

/*!
* tabbable 6.2.0
* @license MIT, https:
*/
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, function () {
    var current = global.tabbable;
    var exports = global.tabbable = {};
    factory(exports);

    exports.noConflict = function () {
      global.tabbable = current;
      return exports;
    };
  }());
})(void 0, function (exports) {
  'use strict';

  var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
  var candidateSelector = candidateSelectors.join(',');
  var NoElement = typeof Element === 'undefined';
  var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
    var _element$getRootNode;

    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
  } : function (element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
  };

  var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;

    if (lookUp === void 0) {
      lookUp = true;
    }

    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    var result = inert || lookUp && node && isInert(node.parentNode);
    return result;
  };

  var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;

    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
  };

  var getCandidates = function getCandidates(el, includeContainer, filter) {
    if (isInert(el)) {
      return [];
    }

    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }

    candidates = candidates.filter(filter);
    return candidates;
  };

  var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);

    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();

      if (isInert(element, false)) {
        continue;
      }

      if (element.tagName === 'SLOT') {
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively(content, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: nestedCandidates
          });
        }
      } else {
        var validCandidate = matches.call(element, candidateSelector);

        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        }

        var shadowRoot = element.shadowRoot || typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
        var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));

        if (shadowRoot && validShadowRoot) {
          var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

          if (options.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scopeParent: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }

    return candidates;
  };

  var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
  };

  var getTabIndex = function getTabIndex(node) {
    if (!node) {
      throw new Error('No node provided');
    }

    if (node.tabIndex < 0) {
      if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
        return 0;
      }
    }

    return node.tabIndex;
  };

  var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);

    if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
      return 0;
    }

    return tabIndex;
  };

  var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };

  var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
  };

  var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  };

  var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
    return r;
  };

  var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };

  var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }

    var radioScope = node.form || getRootNode(node);

    var queryRadios = function queryRadios(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };

    var radioSet;

    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
      }
    }

    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };

  var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  };

  var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };

  var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;

    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    var attached = false;

    if (nodeRoot && nodeRoot !== node) {
      var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;

      attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));

      while (!attached && nodeRootHost) {
        var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;

        nodeRoot = getRootNode(nodeRootHost);
        nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
        attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
      }
    }

    return attached;
  };

  var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  };

  var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck,
        getShadowRoot = _ref.getShadowRoot;

    if (getComputedStyle(node).visibility === 'hidden') {
      return true;
    }

    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
      return true;
    }

    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
      if (typeof getShadowRoot === 'function') {
        var originalNode = node;

        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);

          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            node = rootNode.host;
          } else {
            node = parentElement;
          }
        }

        node = originalNode;
      }

      if (isNodeAttached(node)) {
        return !node.getClientRects().length;
      }

      if (displayCheck !== 'legacy-full') {
        return true;
      }
    } else if (displayCheck === 'non-zero-area') {
      return isZeroArea(node);
    }

    return false;
  };

  var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement;

      while (parentNode) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);

            if (child.tagName === 'LEGEND') {
              return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
            }
          }

          return true;
        }

        parentNode = parentNode.parentElement;
      }
    }

    return false;
  };

  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isInert(node) || isHiddenInput(node) || isHidden(node, options) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }

    return true;
  };

  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
      return false;
    }

    return true;
  };

  var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    }

    return false;
  };

  var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function (item, i) {
      var isScope = !!item.scopeParent;
      var element = isScope ? item.scopeParent : item;
      var candidateTabindex = getSortOrderTabIndex(element, isScope);
      var elements = isScope ? sortByOrder(item.candidates) : element;

      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item: item,
          isScope: isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };

  var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    }

    return sortByOrder(candidates);
  };

  var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([container], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
      });
    } else {
      candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    }

    return candidates;
  };

  var isTabbable = function isTabbable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, candidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorTabbable(options, node);
  };

  var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');

  var isFocusable = function isFocusable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorFocusable(options, node);
  };

  exports.focusable = focusable;
  exports.getTabIndex = getTabIndex;
  exports.isFocusable = isFocusable;
  exports.isTabbable = isTabbable;
  exports.tabbable = tabbable;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
/*!
* focus-trap 7.6.4
* @license MIT, https:
*/


(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('tabbable')) : typeof define === 'function' && define.amd ? define(['exports', 'tabbable'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, function () {
    var current = global.focusTrap;
    var exports = global.focusTrap = {};
    factory(exports, global.tabbable);

    exports.noConflict = function () {
      global.focusTrap = current;
      return exports;
    };
  }());
})(void 0, function (exports, tabbable) {
  'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);

    for (var e = 0, n = Array(a); e < a; e++) {
      n[e] = r[e];
    }

    return n;
  }

  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }

  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }

  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function ownKeys(e, r) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }

    return t;
  }

  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }

    return e;
  }

  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
  }

  function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];

    if (undefined !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }

    return ("string" === r ? String : Number)(t);
  }

  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");

    return "symbol" == _typeof(i) ? i : i + "";
  }

  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined;
    }
  }

  var activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
      if (trapStack.length > 0) {
        var activeTrap = trapStack[trapStack.length - 1];

        if (activeTrap !== trap) {
          activeTrap._setPausedState(true);
        }
      }

      var trapIndex = trapStack.indexOf(trap);

      if (trapIndex === -1) {
        trapStack.push(trap);
      } else {
        trapStack.splice(trapIndex, 1);
        trapStack.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
      var trapIndex = trapStack.indexOf(trap);

      if (trapIndex !== -1) {
        trapStack.splice(trapIndex, 1);
      }

      if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) {
        trapStack[trapStack.length - 1]._setPausedState(false);
      }
    }
  };

  var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  };

  var isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Escape' || (e === null || e === undefined ? undefined : e.key) === 'Esc' || (e === null || e === undefined ? undefined : e.keyCode) === 27;
  };

  var isTabEvent = function isTabEvent(e) {
    return (e === null || e === undefined ? undefined : e.key) === 'Tab' || (e === null || e === undefined ? undefined : e.keyCode) === 9;
  };

  var isKeyForward = function isKeyForward(e) {
    return isTabEvent(e) && !e.shiftKey;
  };

  var isKeyBackward = function isKeyBackward(e) {
    return isTabEvent(e) && e.shiftKey;
  };

  var delay = function delay(fn) {
    return setTimeout(fn, 0);
  };

  var valueOrHandler = function valueOrHandler(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return typeof value === 'function' ? value.apply(undefined, params) : value;
  };

  var getActualTarget = function getActualTarget(event) {
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
  };

  var internalTrapStack = [];

  var createFocusTrap = function createFocusTrap(elements, userOptions) {
    var doc = (userOptions === null || userOptions === undefined ? undefined : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === undefined ? undefined : userOptions.trapStack) || internalTrapStack;

    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true,
      isKeyForward: isKeyForward,
      isKeyBackward: isKeyBackward
    }, userOptions);

    var state = {
      containers: [],
      containerGroups: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      manuallyPaused: false,
      delayInitialFocusTimer: undefined,
      recentNavEvent: undefined
    };
    var trap;

    var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };

    var findContainerIndex = function findContainerIndex(element, event) {
      var composedPath = typeof (event === null || event === undefined ? undefined : event.composedPath) === 'function' ? event.composedPath() : undefined;
      return state.containerGroups.findIndex(function (_ref) {
        var container = _ref.container,
            tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || (composedPath === null || composedPath === undefined ? undefined : composedPath.includes(container)) || tabbableNodes.find(function (node) {
          return node === element;
        });
      });
    };

    var getNodeForOption = function getNodeForOption(optionName) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$hasFallback = _ref2.hasFallback,
          hasFallback = _ref2$hasFallback === undefined ? false : _ref2$hasFallback,
          _ref2$params = _ref2.params,
          params = _ref2$params === undefined ? [] : _ref2$params;

      var optionValue = config[optionName];

      if (typeof optionValue === 'function') {
        optionValue = optionValue.apply(undefined, _toConsumableArray(params));
      }

      if (optionValue === true) {
        optionValue = undefined;
      }

      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        }

        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }

      var node = optionValue;

      if (typeof optionValue === 'string') {
        try {
          node = doc.querySelector(optionValue);
        } catch (err) {
          throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
        }

        if (!node) {
          if (!hasFallback) {
            throw new Error("`".concat(optionName, "` as selector refers to no known node"));
          }
        }
      }

      return node;
    };

    var getInitialFocusNode = function getInitialFocusNode() {
      var node = getNodeForOption('initialFocus', {
        hasFallback: true
      });

      if (node === false) {
        return false;
      }

      if (node === undefined || node && !tabbable.isFocusable(node, config.tabbableOptions)) {
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption('fallbackFocus');
        }
      } else if (node === null) {
        node = getNodeForOption('fallbackFocus');
      }

      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }

      return node;
    };

    var updateTabbableNodes = function updateTabbableNodes() {
      state.containerGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable.tabbable(container, config.tabbableOptions);
        var focusableNodes = tabbable.focusable(container, config.tabbableOptions);
        var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
        var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
        var firstDomTabbableNode = focusableNodes.find(function (node) {
          return tabbable.isTabbable(node);
        });
        var lastDomTabbableNode = focusableNodes.slice().reverse().find(function (node) {
          return tabbable.isTabbable(node);
        });
        var posTabIndexesFound = !!tabbableNodes.find(function (node) {
          return tabbable.getTabIndex(node) > 0;
        });
        return {
          container: container,
          tabbableNodes: tabbableNodes,
          focusableNodes: focusableNodes,
          posTabIndexesFound: posTabIndexesFound,
          firstTabbableNode: firstTabbableNode,
          lastTabbableNode: lastTabbableNode,
          firstDomTabbableNode: firstDomTabbableNode,
          lastDomTabbableNode: lastDomTabbableNode,
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var nodeIdx = tabbableNodes.indexOf(node);

            if (nodeIdx < 0) {
              if (forward) {
                return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function (el) {
                  return tabbable.isTabbable(el);
                });
              }

              return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function (el) {
                return tabbable.isTabbable(el);
              });
            }

            return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function (group) {
        return group.tabbableNodes.length > 0;
      });

      if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus')) {
        throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
      }

      if (state.containerGroups.find(function (g) {
        return g.posTabIndexesFound;
      }) && state.containerGroups.length > 1) {
        throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
      }
    };

    var _getActiveElement = function getActiveElement(el) {
      var activeElement = el.activeElement;

      if (!activeElement) {
        return;
      }

      if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
        return _getActiveElement(activeElement.shadowRoot);
      }

      return activeElement;
    };

    var _tryFocus = function tryFocus(node) {
      if (node === false) {
        return;
      }

      if (node === _getActiveElement(document)) {
        return;
      }

      if (!node || !node.focus) {
        _tryFocus(getInitialFocusNode());

        return;
      }

      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;

      if (isSelectableInput(node)) {
        node.select();
      }
    };

    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus', {
        params: [previousActiveElement]
      });
      return node ? node : node === false ? false : previousActiveElement;
    };

    var findNextNavNode = function findNextNavNode(_ref3) {
      var target = _ref3.target,
          event = _ref3.event,
          _ref3$isBackward = _ref3.isBackward,
          isBackward = _ref3$isBackward === undefined ? false : _ref3$isBackward;
      target = target || getActualTarget(event);
      updateTabbableNodes();
      var destinationNode = null;

      if (state.tabbableGroups.length > 0) {
        var containerIndex = findContainerIndex(target, event);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

        if (containerIndex < 0) {
          if (isBackward) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (isBackward) {
          var startOfGroupIndex = state.tabbableGroups.findIndex(function (_ref4) {
            var firstTabbableNode = _ref4.firstTabbableNode;
            return target === firstTabbableNode;
          });

          if (startOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            startOfGroupIndex = containerIndex;
          }

          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target, false);
          }
        } else {
          var lastOfGroupIndex = state.tabbableGroups.findIndex(function (_ref5) {
            var lastTabbableNode = _ref5.lastTabbableNode;
            return target === lastTabbableNode;
          });

          if (lastOfGroupIndex < 0 && (containerGroup.container === target || tabbable.isFocusable(target, config.tabbableOptions) && !tabbable.isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            lastOfGroupIndex = containerIndex;
          }

          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = tabbable.getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
          } else if (!isTabEvent(event)) {
            destinationNode = containerGroup.nextTabbableNode(target);
          }
        }
      } else {
        destinationNode = getNodeForOption('fallbackFocus');
      }

      return destinationNode;
    };

    var checkPointerDown = function checkPointerDown(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target, e) >= 0) {
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate
        });
        return;
      }

      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }

      e.preventDefault();
    };

    var checkFocusIn = function checkFocusIn(event) {
      var target = getActualTarget(event);
      var targetContained = findContainerIndex(target, event) >= 0;

      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        event.stopImmediatePropagation();
        var nextNode;
        var navAcrossContainers = true;

        if (state.mostRecentlyFocusedNode) {
          if (tabbable.getTabIndex(state.mostRecentlyFocusedNode) > 0) {
            var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
            var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;

            if (tabbableNodes.length > 0) {
              var mruTabIdx = tabbableNodes.findIndex(function (node) {
                return node === state.mostRecentlyFocusedNode;
              });

              if (mruTabIdx >= 0) {
                if (config.isKeyForward(state.recentNavEvent)) {
                  if (mruTabIdx + 1 < tabbableNodes.length) {
                    nextNode = tabbableNodes[mruTabIdx + 1];
                    navAcrossContainers = false;
                  }
                } else {
                  if (mruTabIdx - 1 >= 0) {
                    nextNode = tabbableNodes[mruTabIdx - 1];
                    navAcrossContainers = false;
                  }
                }
              }
            }
          } else {
            if (!state.containerGroups.some(function (g) {
              return g.tabbableNodes.some(function (n) {
                return tabbable.getTabIndex(n) > 0;
              });
            })) {
              navAcrossContainers = false;
            }
          }
        } else {
          navAcrossContainers = false;
        }

        if (navAcrossContainers) {
          nextNode = findNextNavNode({
            target: state.mostRecentlyFocusedNode,
            isBackward: config.isKeyBackward(state.recentNavEvent)
          });
        }

        if (nextNode) {
          _tryFocus(nextNode);
        } else {
          _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
      }

      state.recentNavEvent = undefined;
    };

    var checkKeyNav = function checkKeyNav(event) {
      var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      state.recentNavEvent = event;
      var destinationNode = findNextNavNode({
        event: event,
        isBackward: isBackward
      });

      if (destinationNode) {
        if (isTabEvent(event)) {
          event.preventDefault();
        }

        _tryFocus(destinationNode);
      }
    };

    var checkTabKey = function checkTabKey(event) {
      if (config.isKeyForward(event) || config.isKeyBackward(event)) {
        checkKeyNav(event, config.isKeyBackward(event));
      }
    };

    var checkEscapeKey = function checkEscapeKey(event) {
      if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
        event.preventDefault();
        trap.deactivate();
      }
    };

    var checkClick = function checkClick(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target, e) >= 0) {
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }

      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
    };

    var addListeners = function addListeners() {
      if (!state.active) {
        return;
      }

      activeFocusTraps.activateTrap(trapStack, trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
        _tryFocus(getInitialFocusNode());
      }) : _tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkTabKey, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkEscapeKey);
      return trap;
    };

    var removeListeners = function removeListeners() {
      if (!state.active) {
        return;
      }

      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkTabKey, true);
      doc.removeEventListener('keydown', checkEscapeKey);
      return trap;
    };

    var checkDomRemoval = function checkDomRemoval(mutations) {
      var isFocusedNodeRemoved = mutations.some(function (mutation) {
        var removedNodes = Array.from(mutation.removedNodes);
        return removedNodes.some(function (node) {
          return node === state.mostRecentlyFocusedNode;
        });
      });

      if (isFocusedNodeRemoved) {
        _tryFocus(getInitialFocusNode());
      }
    };

    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;

    var updateObservedNodes = function updateObservedNodes() {
      if (!mutationObserver) {
        return;
      }

      mutationObserver.disconnect();

      if (state.active && !state.paused) {
        state.containers.map(function (container) {
          mutationObserver.observe(container, {
            subtree: true,
            childList: true
          });
        });
      }
    };

    trap = {
      get active() {
        return state.active;
      },

      get paused() {
        return state.paused;
      },

      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }

        var onActivate = getOption(activateOptions, 'onActivate');
        var onPostActivate = getOption(activateOptions, 'onPostActivate');
        var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }

        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        onActivate === null || onActivate === undefined || onActivate();

        var finishActivation = function finishActivation() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }

          addListeners();
          updateObservedNodes();
          onPostActivate === null || onPostActivate === undefined || onPostActivate();
        };

        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }

        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }

        var options = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);

        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = undefined;
        removeListeners();
        state.active = false;
        state.paused = false;
        updateObservedNodes();
        activeFocusTraps.deactivateTrap(trapStack, trap);
        var onDeactivate = getOption(options, 'onDeactivate');
        var onPostDeactivate = getOption(options, 'onPostDeactivate');
        var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
        var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
        onDeactivate === null || onDeactivate === undefined || onDeactivate();

        var finishDeactivation = function finishDeactivation() {
          delay(function () {
            if (returnFocus) {
              _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }

            onPostDeactivate === null || onPostDeactivate === undefined || onPostDeactivate();
          });
        };

        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }

        finishDeactivation();
        return this;
      },
      pause: function pause(pauseOptions) {
        if (!state.active) {
          return this;
        }

        state.manuallyPaused = true;
        return this._setPausedState(true, pauseOptions);
      },
      unpause: function unpause(unpauseOptions) {
        if (!state.active) {
          return this;
        }

        state.manuallyPaused = false;

        if (trapStack[trapStack.length - 1] !== this) {
          return this;
        }

        return this._setPausedState(false, unpauseOptions);
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === 'string' ? doc.querySelector(element) : element;
        });

        if (state.active) {
          updateTabbableNodes();
        }

        updateObservedNodes();
        return this;
      }
    };
    Object.defineProperties(trap, {
      _isManuallyPaused: {
        value: function value() {
          return state.manuallyPaused;
        }
      },
      _setPausedState: {
        value: function value(paused, options) {
          if (state.paused === paused) {
            return this;
          }

          state.paused = paused;

          if (paused) {
            var onPause = getOption(options, 'onPause');
            var onPostPause = getOption(options, 'onPostPause');
            onPause === null || onPause === undefined || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === undefined || onPostPause();
          } else {
            var onUnpause = getOption(options, 'onUnpause');
            var onPostUnpause = getOption(options, 'onPostUnpause');
            onUnpause === null || onUnpause === undefined || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === undefined || onPostUnpause();
          }

          return this;
        }
      }
    });
    trap.updateContainerElements(elements);
    return trap;
  };

  exports.createFocusTrap = createFocusTrap;
});

var subMenus;
var subMenuToggles;
var overflowMenu;

function getSubmenuElements() {
  subMenus = document.querySelectorAll('.subnav-submenu');
  subMenuToggles = document.querySelectorAll('.subnav-submenu-toggle');
}

function toggleSubMenus() {
  subMenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      var subMenuToggle = e.currentTarget;
      var subMenu = document.getElementById(subMenuToggle.getAttribute('aria-controls'));
      toggleWithAria(subMenuToggle, subMenu);
    });
  });
}

function closeOnFocusOutside() {
  var closeSubMenu = function closeSubMenu(subMenu, e) {
    var subMenuToggle = document.querySelector("[aria-controls=".concat(subMenu.getAttribute('id'), "]"));
    closeActiveSubMenu(subMenu, subMenuToggle, e, function () {
      subMenuToggle.setAttribute('aria-expanded', false);
      subMenu.inert = true;
      subMenu.setAttribute('aria-hidden', true);
    });
  };

  var closeOverflowMenu = function closeOverflowMenu(e) {
    var overflowMenuToggle = overflowMenu.getNavElements()['toggle-btn'];
    var overflowMenuEl = overflowMenu.getNavElements()['overflow-nav'];
    closeActiveSubMenu(overflowMenuEl, overflowMenuToggle, e, function () {
      return overflowMenu.setOverflowNavOpen(false);
    });
  };

  document.addEventListener('click', function (e) {
    subMenus.forEach(function (subMenu) {
      closeSubMenu(subMenu, e);
    });
    closeOverflowMenu(e);
  }, true);
  document.addEventListener('keyup', function (e) {
    subMenus.forEach(function (subMenu) {
      closeSubMenu(subMenu, e);
    });
    closeOverflowMenu(e);
  });
}

function closeActiveSubMenu(subMenu, subMenuToggle, e, menuCloseFn) {
  if (subMenu.getAttribute('aria-hidden') === 'false' && e.target !== subMenuToggle && !subMenu.contains(e.target)) {
    menuCloseFn();
  }
}

function toggleWithAria(toggle, target) {
  if (toggle.getAttribute('aria-expanded') === 'false') {
    toggle.setAttribute('aria-expanded', true);
    target.inert = false;
    target.setAttribute('aria-hidden', false);
  } else {
    toggle.setAttribute('aria-expanded', false);
    target.inert = true;
    target.setAttribute('aria-hidden', true);
  }
}

function priorityPlusInit() {
  if (typeof priorityPlus !== 'undefined') {
    overflowMenu = priorityPlus(document.querySelector('.subnav-menu-list'), {
      classNames: {
        'toggle-btn': ['p-plus__toggle-btn', 'subnav-overflow-toggle'],
        'overflow-nav': ['subnav-overflow-list']
      },
      innerToggleTemplate: function innerToggleTemplate(_ref6) {
        var toggleCount = _ref6.toggleCount,
            totalCount = _ref6.totalCount;
        return "\n        <span class=\"subnav-overflow-toggle-label\">\n          ".concat(toggleCount && toggleCount === totalCount ? hireResourcesLinkLabel : overflowMenuToggleLabel, "\n        </span>\n        <span class=\"subnav-caret\" aria-hidden=\"true\"></span>\n      ");
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  priorityPlusInit();
  getSubmenuElements();
  toggleSubMenus();
  closeOnFocusOutside();
  initMobileDrilldown();
  document.querySelector('.subnav-menu').style.visibility = "visible";
});
var hireTranslations = ['hire', 'εταιρείες', '%CE%B5%CF%84%CE%B1%CE%B9%CF%81%CE%B5%CE%AF%CE%B5%CF%82', 'работодатель', '%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB%D1%8C', 'التوظيف', '%D8%A7%D9%84%D8%AA%D9%88%D8%B8%D9%8A%D9%81', 'รับสมัครงาน', '%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%B2%E0%B8%99', '徵才', '%E5%BE%B5%E6%89%8D', '招聘', '%E6%8B%9B%E8%81%98', '求人広告', '%E6%B1%82%E4%BA%BA%E5%BA%83%E5%91%8A', '인재채용', '%EC%9D%B8%EC%9E%AC%EC%B1%84%EC%9A%A9', 'eleman-bul', 'hr', 'nábor-zaměstnanců', 'n%C3%A1bor-zam%C4%9Bstnanc%C5%AF', 'personeel', 'perusahaan', 'reclutamiento', 'recruiting', 'recruitment', 'recrutamento', 'recrutare', 'recrutement', 'rekrutacja', 'rekruttering', 'rekrytera', 'rekrytoi', 'toborzás', 'toborz%C3%A1s', 'tuyển-dụng', 'tuy%E1%BB%83n-d%E1%BB%A5ng'];
var titleCurrencyCharsToFilter = ['$', '£', '€', '¥', '₹'];
var excludeHirePathPrefixes = ['directmail', 'sem-haj', 'acq-'];
var excludeHirePaths = ['pub-credit', '100radio', 'credit50', 'hiretoday', 'onboarding-webinar-promo', 'smbacq_email_0723_75', 'mmacq_email_0723_200', 'mid-market-acquisition-wd-cold-email-feb-2023-200-credit', 'mid-market-acquisition-wd-cold-email-jun-2023-200-credit', 'courrier1', 'solution', 'offre', 'publier-une-annonce-tlmkg', 'trophees-pme-rmc', 'mmacq_email_0923_100'];

function appendParamsOnce(url, params) {
  var useParams = params.replace(/^(\?|\&)/, '');
  var anchorRegExp = new RegExp(/#.*$/);
  var urlAnchorMatch = url.match(anchorRegExp);
  var anchor = urlAnchorMatch == null ? '' : urlAnchorMatch;
  url = url.replace(anchorRegExp, '');

  if (url.match(new RegExp('[\\?|\\&]' + regExpEscape(useParams))) == null) {
    url += (url.indexOf('?') > 0 ? '&' : '?') + useParams;
  }

  url += anchor;
  return url;
}

function regExpEscape(s) {
  return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\\$1').replace(/\x08/g, '\\x08');
}

function formatSitemapTitle(titleText) {
  return titleText.replace(/ ?\[Update.*\] ?/g, '').replace(/ ?\|[\s\S]*/g, '');
}

function calcSitemapElementsArrayFromText(sitemapPageText) {
  var parser = new DOMParser();
  var sitemapHtmlDoc = parser.parseFromString(sitemapPageText, 'text/html');
  var sitemapContentsDiv = sitemapHtmlDoc.getElementById('sitemap');

  if (!sitemapContentsDiv) {
    console.log('Could not parse data from sitemap, may be 404.');
    return [];
  }

  var sitemapEntries = sitemapContentsDiv.getElementsByTagName('a');

  var siteMapEntriesArray = _toConsumableArray2(sitemapEntries);

  var indexPageEntries = siteMapEntriesArray.filter(function (el) {
    return new URL(el.href).pathname.split('/').length <= 3;
  });
  var otherEntries = siteMapEntriesArray.filter(function (el) {
    return new URL(el.href).pathname.split('/').length > 3;
  });
  return [].concat(_toConsumableArray2(indexPageEntries), _toConsumableArray2(otherEntries));
}

function calcSitemapArrayFromElementsArray(sitemapElementsArray) {
  return sitemapElementsArray.map(function (el) {
    return {
      title: formatSitemapTitle(el.innerHTML),
      url: el.href
    };
  });
}

var sitemapPageTextPromise = null;

function fetchSitemapText() {
  if (!sitemapPageTextPromise) {
    console.log('Loading sitemap for search query data, subnavSearchSitemapUrl:', subnavSearchSitemapUrl);
    sitemapPageTextPromise = fetch(subnavSearchSitemapUrl).then(function (response) {
      return response.text();
    })["catch"](function (e) {
      console.log("Failed to load sitemap", e);
      return null;
    });
  }

  return sitemapPageTextPromise;
}

function shouldIncludeSitemapObj(sitemapObj) {
  var path = new URL(sitemapObj.url).pathname.split('/');

  if (!hireTranslations.includes(path[1]) && !(path[1].toLowerCase() === 'lead') && !(path[1] === 'employers' && (subnavSearchSitemapLocale === 'en_LU' || subnavSearchSitemapLocale === 'en_MY'))) {
    return false;
  }

  if (path.length < 2 || path.length > 0 && path[0] !== '') {
    return false;
  }

  if (path.length == 2) {
    return true;
  }

  if (path.length == 3 && (path[2] === 'sitemap' || path[2] === 'cookie')) {
    return false;
  }

  if (path.length == 4 && path[2] === 'internal-components' && path[3] === 'smb-subcategory-menu') {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(titleCurrencyCharsToFilter),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var currencyChar = _step.value;

      if (sitemapObj.title.includes(currencyChar)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(excludeHirePathPrefixes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var excludePrefix = _step2.value;

      if (path[2].startsWith(excludePrefix)) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var pathSectionsAfterFirst = path.slice(2, undefined).join('/');
  var isExcludedHirePath = excludeHirePaths.includes(pathSectionsAfterFirst);
  return !isExcludedHirePath;
}

function filterSitemapArray(sitemapArray) {
  return sitemapArray.filter(shouldIncludeSitemapObj);
}

var sitemapObjListPromise = null;

function fetchSitemapAsObjList() {
  if (!sitemapObjListPromise) {
    sitemapObjListPromise = fetchSitemapText().then(function (sitemapText) {
      console.log('Converting sitemap text to list of objects.');
      var sitemapElementsArray = calcSitemapElementsArrayFromText(sitemapText);
      var sitemapArray = calcSitemapArrayFromElementsArray(sitemapElementsArray);
      return filterSitemapArray(sitemapArray);
    });
  }

  return sitemapObjListPromise;
}

function displaySuggestion(sitemapPage) {
  var url = new URL(sitemapPage.url);

  if (typeof subnavSearchSourceId === 'string' && subnavSearchSourceId.trim()) {
    url.searchParams.set("isid", subnavSearchSourceId);
    url.searchParams.set("ikw", "subnav_search_ikw");
  }

  return "<div><a tabindex=\"-1\" href=\"".concat(url.href, "\">").concat(sitemapPage.title, "</a></div>");
}

function displaySuggestionsHeading() {
  return "<div class=\"custom-tt-header\">".concat(subnavSearchSuggestionsHeading, "</div>");
}

function escapeHtmlAttr(str) {
  if (str == null) return '';
  return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function displayPendingSpinner() {
  var loadingLabel = subnavSearchLoadingLabel;
  var ariaLabel = loadingLabel || 'Loading';
  return "<div class=\"subnav-search-loading\">\n        <div class=\"spinner\" role=\"status\" aria-live=\"polite\" aria-label=\"".concat(escapeHtmlAttr(ariaLabel), "\"></div>\n        ").concat(loadingLabel ? "<span class=\"search-state-label\">".concat(escapeHtmlAttr(loadingLabel), "</span>") : '', "\n    </div>");
}

function displayNotFound() {
  var notFoundLabel = subnavSearchNotFoundLabel;
  var ariaLabel = notFoundLabel || 'No results found';
  return "<div class=\"subnav-search-not-found\">\n        <div class=\"ban-icon\" role=\"img\" aria-label=\"".concat(escapeHtmlAttr(ariaLabel), "\"></div>\n        ").concat(notFoundLabel ? "<span class=\"search-state-label\">".concat(escapeHtmlAttr(notFoundLabel), "</span>") : '', "\n    </div>");
}

var addedToBloodhound = false;

function searchInputTypeaheadInit() {
  if (!window.Bloodhound) {
    return;
  }

  var bloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: function identify(sitemapPageObj) {
      return sitemapPageObj.title;
    }
  });
  var subnavSeachInputJQuery = subnavJQuery('#subnav-search-input');

  if (!subnavSeachInputJQuery.length) {
    return;
  }

  subnavSeachInputJQuery.typeahead({
    highlight: true,
    hint: true,
    minLength: 3
  }, {
    name: 'sitemap',
    limit: 6,
    async: true,
    source: function source(query, syncResults, asyncResults) {
      bloodhound.search(query, syncResults);

      if (addedToBloodhound) {
        asyncResults([]);
      }
    },
    display: 'title',
    templates: {
      pending: displayPendingSpinner,
      notFound: displayNotFound,
      suggestion: displaySuggestion,
      header: displaySuggestionsHeading
    }
  }).on('typeahead:select', function (ev, selection) {
    location.href = selection.url;
  }).on('typeahead:active', function (ev) {
    fetchSitemapAsObjList().then(function (sitemapObjList) {
      if (!addedToBloodhound) {
        addedToBloodhound = true;
        console.log('Fetched search data from sitemap, adding to Bloodhound.');
        bloodhound.add(sitemapObjList);
        var currentVal = subnavSeachInputJQuery.typeahead('val');
        subnavSeachInputJQuery.typeahead('val', '');
        subnavSeachInputJQuery.typeahead('val', currentVal);
      }
    });
  });
}

var searchBoxQ = function searchBoxQ() {
  return document.querySelector('.search-box');
};

var toggleSearchButtonQ = function toggleSearchButtonQ() {
  return document.querySelector('.toggle-search');
};

var clearInputButtonQ = function clearInputButtonQ() {
  return document.querySelector('.clear-input-button');
};

var searchInputQ = function searchInputQ() {
  return document.querySelector('#subnav-search-input');
};

function searchBoxInit() {
  var searchBox = searchBoxQ();
  var toggleSearchButton = toggleSearchButtonQ();
  var clearInputButton = clearInputButtonQ();
  var searchInput = searchInputQ();

  if (searchBox && toggleSearchButton && clearInputButton && searchInput) {
    searchBox.addEventListener('keydown', handleEscapeKeyClose);
    toggleSearchButton.addEventListener('keydown', handleEscapeKeyClose);
    toggleSearchButton.addEventListener('click', toggleSearchBox);
    clearInputButton.addEventListener('click', clearInput);
    searchInput.addEventListener('input', onInputChange);
  }
}

function toggleSearchBox() {
  var searchBox = searchBoxQ();
  var searchInput = searchInputQ();
  var toggleSearchButton = toggleSearchButtonQ();

  if (!searchBox.classList.contains('displayed')) {
    searchBox.classList.add('displayed');
    toggleSearchButton.classList.add('enabled');
    searchInput.focus();
    document.addEventListener('click', handleDocumentClick);
  } else {
    closeSearch();
  }
}

function closeSearch() {
  var toggleSearchButton = toggleSearchButtonQ();
  var searchBox = searchBoxQ();
  document.removeEventListener('click', handleDocumentClick);
  searchBox.classList.remove('displayed');
  toggleSearchButton.classList.remove('enabled');
}

function handleEscapeKeyClose(event) {
  if (event.key === 'Escape') {
    closeSearch();
  }
}

function handleDocumentClick(event) {
  if (!event.target.closest(".search-container")) {
    closeSearch();
  }
}

function onInputChange() {
  var clearInputButton = clearInputButtonQ();
  var currentVal = subnavJQuery('#subnav-search-input').typeahead('val');

  if (currentVal) {
    clearInputButton.classList.add('displayed');
  } else {
    clearInputButton.classList.remove('displayed');
  }
}

function clearInput() {
  var searchInput = searchInputQ();
  var clearInputButton = clearInputButtonQ();
  searchInput.focus();
  clearInputButton.classList.remove('displayed');
  subnavJQuery('#subnav-search-input').typeahead('val', '');
}

var mobileDrilldownToggle = null;
var mobileDrilldownPanel = null;
var mobileDrilldownNav = null;
var mobileDrilldownBloodhoundReady = false;
var mobileDrilldownLastTrigger = null;
var mobileDrilldownFocusTrap = null;

function initMobileDrilldown() {
  mobileDrilldownToggle = document.querySelector('.mobile-drilldown-toggle');
  mobileDrilldownPanel = document.getElementById('mobile-drilldown-panel');
  mobileDrilldownNav = document.querySelector('.mobile-drilldown-nav');
  if (!mobileDrilldownToggle || !mobileDrilldownPanel || !mobileDrilldownNav) return;
  mobileDrilldownToggle.addEventListener('click', handleMobileDrilldownToggle);
  mobileDrilldownPanel.querySelectorAll('.mobile-drilldown-category-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      showMobileDrilldownLevel2(button.getAttribute('data-target'));
    });
  });
  mobileDrilldownPanel.querySelectorAll('.mobile-drilldown-back-btn').forEach(function (button) {
    button.addEventListener('click', showMobileDrilldownLevel1);
  });
  initMobileDrilldownSearch();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      closeMobileDrilldown();
    }
  });
  window.addEventListener('resize', function () {
    if (mobileDrilldownPanel.getAttribute('aria-hidden') === 'false') {
      if (window.innerWidth >= 768) {
        closeMobileDrilldown();
        return;
      }

      updateMobileDrilldownHeight();
    }
  });
}

function updateMobileDrilldownHeight() {
  var panelTop = mobileDrilldownPanel.getBoundingClientRect().top;
  mobileDrilldownPanel.style.setProperty('--mobile-drilldown-height', window.innerHeight - panelTop + 'px');
}

function ensureMobileDrilldownFocusTrap() {
  if (mobileDrilldownFocusTrap || !window.focusTrap) return mobileDrilldownFocusTrap;
  mobileDrilldownFocusTrap = window.focusTrap.createFocusTrap(mobileDrilldownNav, {
    escapeDeactivates: true,
    clickOutsideDeactivates: true,
    returnFocusOnDeactivate: false,
    onDeactivate: closeMobileDrilldown
  });
  return mobileDrilldownFocusTrap;
}

function handleMobileDrilldownToggle() {
  if (mobileDrilldownToggle.getAttribute('aria-expanded') === 'true') {
    closeMobileDrilldown();
    return;
  }

  mobileDrilldownToggle.setAttribute('aria-expanded', 'true');
  mobileDrilldownPanel.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('mobile-drilldown-scroll-lock');
  updateMobileDrilldownHeight();
  var trap = ensureMobileDrilldownFocusTrap();
  if (trap) trap.activate();
}

function closeMobileDrilldown() {
  if (!mobileDrilldownToggle || mobileDrilldownToggle.getAttribute('aria-expanded') !== 'true') return;
  var shouldRestoreFocus = mobileDrilldownPanel.contains(document.activeElement);
  mobileDrilldownToggle.setAttribute('aria-expanded', 'false');
  mobileDrilldownPanel.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('mobile-drilldown-scroll-lock');
  mobileDrilldownPanel.querySelectorAll('[data-level="2"]').forEach(function (level2) {
    level2.classList.remove('mobile-drilldown-level--active', 'mobile-drilldown-level--slide-in-right');
    level2.setAttribute('aria-hidden', 'true');
  });
  var level1 = mobileDrilldownPanel.querySelector('[data-level="1"]');

  if (level1) {
    level1.classList.remove('mobile-drilldown-level--slide-in-left');
    level1.classList.add('mobile-drilldown-level--active');
  }

  var searchWrapper = mobileDrilldownPanel.querySelector('.mobile-drilldown-search--suggestions-open');

  if (searchWrapper) {
    searchWrapper.classList.remove('mobile-drilldown-search--suggestions-open');
  }

  mobileDrilldownPanel.querySelectorAll('.mobile-drilldown-category-btn').forEach(function (button) {
    button.setAttribute('aria-expanded', 'false');
  });
  mobileDrilldownLastTrigger = null;

  if (shouldRestoreFocus) {
    mobileDrilldownToggle.focus();
  }

  if (mobileDrilldownFocusTrap && mobileDrilldownFocusTrap.active) {
    mobileDrilldownFocusTrap.deactivate({
      onDeactivate: null
    });
  }
}

function showMobileDrilldownLevel2(panelId) {
  var level1 = mobileDrilldownPanel.querySelector('[data-level="1"]');
  var level2 = mobileDrilldownPanel.querySelector('[data-panel-id="' + panelId + '"]');
  if (!level1 || !level2) return;
  level1.classList.remove('mobile-drilldown-level--active', 'mobile-drilldown-level--slide-in-left');
  level2.setAttribute('aria-hidden', 'false');
  level2.classList.add('mobile-drilldown-level--active', 'mobile-drilldown-level--slide-in-right');
  var targetButton = mobileDrilldownPanel.querySelector('[data-target="' + panelId + '"]');

  if (targetButton) {
    mobileDrilldownLastTrigger = targetButton;
    targetButton.setAttribute('aria-expanded', 'true');
  }

  var backButton = level2.querySelector('.mobile-drilldown-back-btn');

  if (backButton) {
    backButton.focus();
  }
}

function showMobileDrilldownLevel1() {
  var level1 = mobileDrilldownPanel.querySelector('[data-level="1"]');
  if (!level1) return;
  mobileDrilldownPanel.querySelectorAll('[data-level="2"]').forEach(function (level2) {
    level2.classList.remove('mobile-drilldown-level--active', 'mobile-drilldown-level--slide-in-right');
    level2.setAttribute('aria-hidden', 'true');
  });
  level1.classList.add('mobile-drilldown-level--active', 'mobile-drilldown-level--slide-in-left');
  mobileDrilldownPanel.querySelectorAll('.mobile-drilldown-category-btn').forEach(function (button) {
    button.setAttribute('aria-expanded', 'false');
  });

  if (mobileDrilldownLastTrigger && document.contains(mobileDrilldownLastTrigger)) {
    mobileDrilldownLastTrigger.focus();
  }

  mobileDrilldownLastTrigger = null;
}

function initMobileDrilldownSearch() {
  if (!window.Bloodhound || typeof subnavJQuery === 'undefined') return;
  var searchInput = mobileDrilldownPanel.querySelector('.mobile-drilldown-search-input');
  if (!searchInput) return;
  var jQueryInput = subnavJQuery(searchInput);
  var searchWrapper = searchInput.closest('.mobile-drilldown-search');
  var bloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: function identify(sitemapPageObj) {
      return sitemapPageObj.title;
    }
  });

  function refreshSuggestions() {
    var currentVal = jQueryInput.typeahead('val');

    if (currentVal && currentVal.length >= 3) {
      jQueryInput.typeahead('val', '');
      jQueryInput.typeahead('val', currentVal);
    }
  }

  jQueryInput.typeahead({
    highlight: true,
    hint: true,
    minLength: 3
  }, {
    name: 'mobile-sitemap',
    limit: 4,
    async: true,
    source: function source(query, syncResults, asyncResults) {
      bloodhound.search(query, syncResults);

      if (mobileDrilldownBloodhoundReady) {
        asyncResults([]);
      }
    },
    display: 'title',
    templates: {
      pending: displayPendingSpinner,
      notFound: displayNotFound,
      suggestion: displaySuggestion,
      header: displaySuggestionsHeading
    }
  }).on('typeahead:select', function (event, selection) {
    location.href = selection.url;
  }).on('typeahead:render', function () {
    requestAnimationFrame(function () {
      var hasContent = !!searchWrapper.querySelector('.tt-menu .tt-suggestion, .tt-menu .subnav-search-not-found, .tt-menu .subnav-search-loading');
      searchWrapper.classList.toggle('mobile-drilldown-search--suggestions-open', hasContent);
    });
  }).on('typeahead:active', function () {
    fetchSitemapAsObjList().then(function (sitemapObjList) {
      if (!mobileDrilldownBloodhoundReady) {
        mobileDrilldownBloodhoundReady = true;
        bloodhound.add(sitemapObjList);
        refreshSuggestions();
      }
    })["catch"](function (error) {
      console.error('Mobile drilldown search failed:', error);
    });
  });
  searchInput.addEventListener('input', function () {
    if (searchInput.value.length < 3) {
      searchWrapper.classList.remove('mobile-drilldown-search--suggestions-open');
    }
  });
  searchInput.addEventListener('focus', refreshSuggestions);
}
